export default __webpack_public_path__ + "static/media/Elixir of Mystical Replenishment.3b32ee75.jpg";